import { render, staticRenderFns } from "./TermSelect.vue?vue&type=template&id=4e112d03"
import script from "./TermSelect.vue?vue&type=script&lang=js"
export * from "./TermSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports